import { PencilOutlineIcon } from './PencilOutlineIcon';

/**
 * author: Google
 * id A17D67B7-C5FF-45E2-91AE-975584067388
 * name pencil-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-outline.svg
 * tags
 * - Drawing / Art 
 * - Edit / Modify 
 */
export const ModeEditOutlineIcon = PencilOutlineIcon;
export default ModeEditOutlineIcon